import { AppBar, Button, Grid, Input, Toolbar, Typography } from '@material-ui/core';
import Alert from 'components/Shared/Alert';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { WithStyles } from 'decorators/withStyles';
import * as React from 'react';
import { PureComponent } from 'react';
import rxjsOperators from 'rxjs-operators';
import themeCustomizerService from 'services/themeCustomizer';
import DialogSave from './DialogSave/index';

interface IProps {
  classes?: any;
}

interface IState {
  themeName: string;
  openDialog: boolean;
  openCancelDialog: boolean;
}

@WithStyles(theme => ({
  appBar: {
    backgroundColor: theme.variables.colors['customizerAppBarBackground']
  },
  previousButton: {
    cursor: 'pointer',
    margin: '0 20px 0 0',
    '& svg': {
      width: 10,
      fill: '#FFF'
    }
  },
  logo: {
    '& svg': {
      width: 130,
      fill: '#FFF'
    }
  },
  labelThemeName: {
    color: '#FFF'
  },
  themeNameGrid: {
    display: 'flex',
    alignItems: 'center'
  },
  inputThemeName: {
    margin: '0 16px',
    width: 300
  },
  saveTheme: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  saveThemeDraftButton: {
    textTransform: 'none',
    border: 'none',
    color: '#FFF',
    margin: `0 ${theme.spacing.unit}px`,
    '&:hover': {
      filter: 'brightness(50%)'
    }
  },
  saveThemeButton: {
    textTransform: 'none',
    backgroundColor: '#FFF',
    color: theme.variables.colors['success'],
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 6}px`,
    margin: `0 ${theme.spacing.unit * 2}px`,
    '&:hover': {
      filter: 'brightness(75%)'
    }
  }
}))
export default class CustomizerAppBar extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { themeName: '', openDialog: false, openCancelDialog: false };
  }

  componentDidMount() {
    themeCustomizerService
      .getData()
      .pipe(
        rxjsOperators.map(theme => theme.themeName || ''),
        rxjsOperators.bindComponent(this),
        rxjsOperators.logError()
      )
      .subscribe((themeName: string) => {
        this.setState({ themeName });
      });
  }

  handleChange = (event: any) => {
    this.setState({ themeName: event.target.value });
    themeCustomizerService.setData({ themeName: event.target.value });
  };

  handleClose = () => {
    themeCustomizerService.closeCustomizer();
  };

  handleCloseDialog = () => {
    this.setState({ openDialog: false });
  };

  toggleDialogCancel = () => {
    this.setState({ openCancelDialog: !this.state.openCancelDialog });
  };
  save = () => {
    if (this.state.themeName.trim().length > 0) {
      themeCustomizerService.saveCustomization();
      return;
    }

    this.setState({ openDialog: true });
  };

  render() {
    const { classes } = this.props;
    const { openDialog, themeName, openCancelDialog } = this.state;

    return (
      <AppBar className={classes.appBar} position="static" color="primary">
        <Toolbar>
          <Grid item xs={2}>
            <div className={classes.logo}>
              <SvgIcon name="checkoutSunCheckoutMaker" />
            </div>
          </Grid>
          <Grid item xs={5} className={classes.themeNameGrid}>
            <Typography variant="subtitle1" className={classes.labelThemeName} noWrap>
              Nome do Tema
            </Typography>
            <Input
              className={classes.inputThemeName}
              disableUnderline={true}
              id="template-name"
              value={themeName}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={5} className={classes.saveTheme}>
            <Button variant="outlined" className={classes.saveThemeDraftButton} onClick={this.toggleDialogCancel}>
              Cancelar
            </Button>
            <Button variant="contained" className={classes.saveThemeButton} onClick={this.save}>
              Salvar
            </Button>
          </Grid>
        </Toolbar>

        <Alert
          opened={openDialog}
          title={'Nome do tema'}
          message={'Por favor, preencha o nome do tema corretamente'}
          onClose={this.handleCloseDialog}
        />
        <DialogSave
          opened={openCancelDialog}
          title={'Descartar alterações'}
          text={'Todas as alterações realizadas serão perdidas. Deseja continuar?'}
          handleContinue={this.handleClose}
          handleSaveSketch={this.save}
          handleClose={this.toggleDialogCancel}
        />
      </AppBar>
    );
  }
}
